var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7499 71.5277V75.6944C43.7499 78.7627 46.2372 81.25 49.3055 81.25H60.4165M77.083 49.3055V45.1389C77.083 42.0706 74.5957 39.5833 71.5275 39.5833L60.4165 39.5833M60.4165 39.5833H53.2182C47.989 39.5833 43.7498 43.8224 43.7498 49.0517C43.7498 53.0839 46.3034 56.6737 50.1125 57.9963L71.6294 65.4674C74.8943 66.6011 77.0831 69.6781 77.0831 73.1343C77.0831 77.6165 73.4495 81.25 68.9673 81.25H60.4165M60.4165 39.5833V32.6388M60.4165 81.25L60.4165 88.1944M110.417 60.4166C110.417 88.0309 88.0307 110.417 60.4165 110.417C32.8023 110.417 10.4165 88.0309 10.4165 60.4166C10.4165 32.8024 32.8023 10.4166 60.4165 10.4166C88.0308 10.4166 110.417 32.8024 110.417 60.4166Z",
    stroke: "#EF233C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.2d5a0600aecf6c8f714427cf742104b4.svg";
export { ForwardRef as ReactComponent };